import script from "./CustomerProfileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerProfileHeader.vue?vue&type=script&setup=true&lang=js"

import "./CustomerProfileHeader.vue?vue&type=style&index=0&id=7415d7ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7415d7ab"]])

export default __exports__

/* vue-cli-plugin-import-components */

import CustomerActionsMenu from "@/components/customers/CustomerActionsMenu.vue";
import NeueTabs from "@/components/neue/NeueTabs.vue";
script.components = Object.assign({}, { CustomerActionsMenu, NeueTabs }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { CustomerActionsMenu, NeueTabs }, script.__o.components);}